
 import { useState, useEffect, useRef } from "react";
 import { Formik } from "formik";
 import * as Yup from "yup";
 import PhoneInput from "react-phone-number-input";
 import "react-phone-number-input/style.css";
import { GetUser } from "../../helpers";

 
 const AddAddressCreateOrder = ({customer,setAddNewAddress, setCustomerAddresses, handleCloseAddress, handleCloseEdit}) => {
   const formikRef = useRef(null);
 
   const [pinCode, setPinCode] = useState("");
   const [pinCodeError, setPinCodeError] = useState("");
   const [autoAddress, setAutoAddress] = useState({ city: "", state: "", country: "" });
 

   useEffect(() => {
     const fetchAddress = async () => {
       if (pinCode.length >= 5) {
         try {
           const res = await fetch(`https://api.postcodes.io/postcodes/${pinCode}`);
           const data = await res.json();
 
           if (data.status === 200) {
             setAutoAddress({
               city: data.result.admin_district || "",
               state: data.result.region || "",
               country: data.result.country === "England" ? "United Kingdom" : data.result.country
             });
             setPinCodeError("");
           } else {
             setAutoAddress({ city: "", state: "", country: "" });
             setPinCodeError("Invalid postcode");
           }
         } catch {
           setAutoAddress({ city: "", state: "", country: "" });
           setPinCodeError("Error verifying postcode");
         }
       } else {
         setPinCodeError("");
         setAutoAddress({ city: "", state: "", country: "" });
       }
     };
 
     fetchAddress();
   }, [pinCode]);
 
   useEffect(() => {
     if (formikRef.current) {
       const { setFieldValue } = formikRef.current;
       setFieldValue("city", autoAddress.city);
       setFieldValue("state", autoAddress.state);
       setFieldValue("country", autoAddress.country);
     }
   }, [autoAddress]);
 
   const validationSchema = Yup.object({
     full_name: Yup.string().required("Full name is required"),
     address_line_1: Yup.string().required("Address line 1 is required"),
     city: Yup.string().required("City is required"),
     state: Yup.string().required("State is required"),
     pin_code: Yup.string()
       .required("Post code is required")
       .matches(/^\S+$/, "Post code must not contain spaces")
       .min(5, "Post code must be at least 5 characters")
       .max(9, "Post code must be at most 9 characters"),
     country: Yup.string().required("Country is required"),
     phone_number: Yup.string()
       .required("Phone number is required")
       .matches(/^(?:\+44|0)7\d{9}$/, "Invalid UK phone number"),
   });
 
 
   const handleSubmit = async (values, {setSubmitting, resetForm})=>{
      let userId = customer.id;
      const resp = await GetUser.addNewAddress(userId, values);
      if(resp && resp.status){
         setAddNewAddress(false);
         setCustomerAddresses(prev => [...prev, resp.address]);
      }
   }
   return (
     <>
    
        <Formik
       innerRef={formikRef}
       initialValues={{
         full_name: "",
         address_line_1: "",
         address_line_2: "",
         address_line_3: "",
         city: "",
         state: "",
         pin_code: "",
         country: "",
         phone_number: "",
       }}
       validationSchema={validationSchema}
       onSubmit={handleSubmit}
     >
       {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldTouched }) => (
         <form onSubmit={handleSubmit}>
           <div className="form-group row">
             <div className="col-md-12">
               <label>Full Name</label>
               <input
                 type="text"
                 className="form-control"
                 name="full_name"
                 onChange={handleChange}
                 onBlur={handleBlur}
                 value={values.full_name}
               />
               {errors.full_name && touched.full_name && <span className="helpError">{errors.full_name}</span>}
             </div>
           </div>
 
           <div className="form-group">
             <label>Phone Number</label>
             <PhoneInput
               country="GB"
               defaultCountry="GB"
               international
               placeholder="Enter phone number"
               value={values.phone_number}
               onChange={(value) => setFieldValue("phone_number", value)}
               onBlur={() => setFieldTouched("phone_number", true)}
               className="form-control"
             />
             {errors.phone_number && touched.phone_number && <span className="helpError">{errors.phone_number}</span>}
           </div>
 
           <div className="form-group row">
             <div className="col-md-12">
               <label>Postcode</label>
               <input
                 type="text"
                 className="form-control"
                 name="pin_code"
                 onChange={(e) => {
                   handleChange(e);
                   setPinCode(e.target.value.toUpperCase());
                 }}
                 onBlur={handleBlur}
                 value={values.pin_code}
                 style={{ textTransform: "uppercase" }}
               />
               {errors.pin_code && touched.pin_code && <span className="helpError">{errors.pin_code}</span>}
               {pinCodeError && <span className="helpError">{pinCodeError}</span>}
             </div>
           </div>
 
           <div className="form-group row">
             <div className="col-md-12">
               <label>Address Line 1</label>
               <input
                 type="text"
                 className="form-control"
                 name="address_line_1"
                 onChange={handleChange}
                 onBlur={handleBlur}
                 value={values.address_line_1}
                  placeholder="Street address, P.O. box, company name, c/o"
               />
               {errors.address_line_1 && touched.address_line_1 && <span className="helpError">{errors.address_line_1}</span>}
             </div>
             <div className="col-md-12">
               <label>Address Line 2</label>
               <input
                 type="text"
                 className="form-control"
                 name="address_line_2"
                 onChange={handleChange}
                 onBlur={handleBlur}
                 value={values.address_line_2}
                  placeholder="Apt, suite, unit, building, floor, etc."
               />
             </div>
           </div>
 
           <div className="form-group row">
             <div className="col-md-6">
               <label>City</label>
               <input
                 type="text"
                 className="form-control"
                 name="city"
                 onChange={handleChange}
                 onBlur={handleBlur}
                 value={values.city}
               />
               {errors.city && touched.city && <span className="helpError">{errors.city}</span>}
             </div>
             <div className="col-md-6">
               <label>State / Province / Region</label>
               <input
                 type="text"
                 className="form-control"
                 name="state"
                 onChange={handleChange}
                 onBlur={handleBlur}
                 value={values.state}
               />
               {errors.state && touched.state && <span className="helpError">{errors.state}</span>}
             </div>
           </div>
 
           <div className="form-group row">
             <div className="col-md-12">
               <label>Country</label>
               <input
                 type="text"
                 className="form-control"
                 name="country"
                 onChange={handleChange}
                 onBlur={handleBlur}
                 value={values.country}
               />
               {errors.country && touched.country && <span className="helpError">{errors.country}</span>}
             </div>
           </div>
 
           <div className="text-center">
             <button type="submit" className="btn btn-primary">
               Submit
             </button>
           </div>
         </form>
       )}
     </Formik>
     </>
   
   );
 };
 
 export default AddAddressCreateOrder;
 